import { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";

const ResumeSubUseForm = (sectionId) => {
  const editorData = useSelector((state) => state.editorData[sectionId]);
  const [resumeFields, setResumeFields] = useState(editorData);

  const sectionTitleRemove = () => {
    let data = { ...resumeFields, customTitle: "", initialLoad: false };
    setResumeFields(data);
  };

  return {
    sectionTitleRemove,
  };
};

export default ResumeSubUseForm;
